const initialState = {
    fetchState: null
};

// eslint-disable-next-line default-param-last
export default function fetchStateReducer(state = initialState, action) {
    switch (action.type) {
        case 'FETCH_START':
            state.fetchState = 'START';
            return { ...state };
        case 'FETCH_END':
            state.fetchState = 'END';
            return { ...state };
        default:
            return state;
    }
}
